export const ConfiguredChartGridLines = (props: Record<string, unknown>): JSX.Element => {
  
  const {
    axis_settings,
    chart_settings
  } = props || {}
   
  const horizontal_props = axis_settings?.left || axis_settings?.right || undefined
  const vertical_props = axis_settings?.bottom || axis_settings?.top || undefined
  
  const horz_ticks = horizontal_props?.ticks || []
  const vert_ticks = vertical_props?.ticks || []

  const horz_lines = horz_ticks?.map((tick, i) => {
    const {scale} = horizontal_props || {}
    return `${scale?.(tick) || 0}px`
  })

  const vert_lines = vert_ticks?.map((tick, i) => {
    const {scale, scale_type} = vertical_props || {}
    let pos = 0
    if (scale_type === 'time') pos = scale?.(new Date(tick)) || 0
    else pos = scale?.(tick) || 0
    return `${pos}px`
  })
 
  return <>
     
    {horz_lines?.map((tick, i) => {
      return (
        <div key={`${tick}-${i}h`} style={{top: tick}} className='abs grid-line grid-line--horizontal'> </div>
      )
    })}

    {chart_settings?.chart_type !== 'bar' && vert_lines?.map((tick, i) => {
        return (
          <div key={`${tick}-${i}v`} style={{left: tick}} className='abs grid-line grid-line--vertical'> </div>
        )
      })}
      
  </>
}